<template>
  <v-card color="grey lighten-5" flat>
    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-tooltip bottom>
          <v-btn @click="miniSaticiEkle()" slot="activator" icon>
            <v-icon color="info" medium>add</v-icon>
          </v-btn>
          <span>{{ label }}</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <snackbarcomp v-bind:mesaj="mesaj" v-model="snackbar"></snackbarcomp>
    <v-dialog v-model="dialogShow" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">{{ label }}</v-card-title>
        <v-card-text>
          <v-form ref="formsatici" v-model="valid" lazy-validation>
            <v-layout row="" wrap="">
              <v-flex xs12 sm12 md12>
                <v-layout row wrap justify-space-between column>
                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                      label="İsim"
                      v-model="Satici.Isim"
                    >
                    </v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field
                      :rules="[
                        (v) => !!v || $t('Mandatory-Areas'),
                        () =>
                          (!!Satici.Kod && Satici.Kod.length <= 50) ||
                          '50 karakterden fazla olamaz',
                      ]"
                      label="Kod (max 50)"
                      v-model="Satici.Kod"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-select
                      :items="saticiTipi"
                      v-model="Satici.Ic_Dis"
                      item-text="text"
                      item-value="value"
                      :label="$t('Seller-Type')"
                    >
                    </v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-textarea :label="$t('Address_label')" v-model="Satici.Adres">
                    </v-textarea>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-text-field :label="$t('Telephone')" v-model="Satici.Tel1">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click.native="dialogShow = false">{{
            $t("cancel_button")
          }}</v-btn>

          <v-btn color="info" flat @click="Kaydet()">{{
            $t("save_button")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import rez from "../rezervasyon";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import tool from "../tools";

export default {
  components: {
    snackbarcomp,
  },
  watch: {},

  props: ["value", "label", "saticiKod"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    pansiyon: {
      get: function () {
        return rez.Pansiyon;
      },
    },
  },

  data() {
    return {
      dialogShow: false,

      Satici: {
        SaticiTipi: 0,
        Ref: null,
        SirketNo: null,
        Kod: null,
        Isim: null,
        Cari_Kod: {
          id: null,
          kod: null,
          isim: null,
        },
        Adres: null,
        PK: null,
        Ulke: null,
        Sehir: null,
        Yer: null,
        SaticiKonumu: null,
        Yetkili: null,
        Web: null,
        HavaAlani: null,
        VDaire: null,
        VNo: null,
        Tel1: null,
        Tel2: null,
        Fax: null,
        Teleks: null,
        Email: null,
        GSM: null,
        Ic_Dis: 0,
        Aciklamalar: null,
        LocationF: null,
        OdaTanimlari: null,
        OtelOzellikleri: null,
        krdDerece: null,
        krdDakika: null,
        krdSaniye: null,
        krdDereceM: null,
        krdDakikaM: null,
        krdSaniyeM: null,
        Grup: null,
        PasifKayit: false,
        GlobalKod: null,
        ZincirKodu: null,
        CreatedBy: null,
        CreatedDate: null,
        ModifiedBy: null,
        ModifiedDate: null,
        AutoCreate: null,
        stOtel: {
          Ucretsizler: [],
          Ucretliler: [],
          Kategori: null,
          GenelMudur: null,
          SatisMuduru: null,
          MuhasebeMuduru: null,
          Donem1: null,
          Donem2: null,
          BarLokanta: null,
          KonferansOda: null,
          OdaKonum: [],
          MinKisi: null,
          OpSure: null,
          Bedava1: null,
          Bedava2: null,
          Cocuk1: null,
          Cocuk2: null,
          OtelTip: null,
          AutoCreate: null,
        },
        stArac: {
          AracTipi: [],
          Donem1: null,
          Donem2: null,
        },
        stRestaurant: {
          KisiYaz: 0,
          KisiKis: 0,
          MinKisi: 0,
          Sorumlu1: null,
          Sorumlu2: null,
          Sinif: null,
          Donem1: null,
          Donem2: null,
          Menu: [],
        },
        stAcente: {
          AcenteTipi: null,
          Sorumlu1: null,
          Sorumlu2: null,
          Donem1: null,
          Donem2: null,
          Turlar: [],
          TransferTasima: [],
          AcenteTip: 0, //0 merkez- 1 tali
          Kurumsal: false,
          Parola: null,
          AnaAcenteKod: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
        },
        stRentACar: {
          AracTipi: [],
          Donem1: null,
          Donem2: null,
          Araclar: [],
        },
        stRehber: {
          Diller: [],
          Cinsiyet: 0,
          Sinif: null,
          Donem1: null,
          Donem2: null,
        },

        stMuze: {
          Donem1: null,
          Donem2: null,
          AcikGunler: {
            Pazartesi: false,
            Sali: false,
            Carsamba: false,
            Persembe: false,
            Cuma: false,
            Cumartesi: false,
            Pazar: false,
          },
          AcikSaat1: null,
          AcikSaat2: null,
          AcikSaat3: null,
        },
        stCharter: {
          Ucaklar: [],
          Donem1: null,
          Donem2: null,
          OpSure: 0,
          FormNo: null,
          HY_Kodu: null,
          Parkur: [],
        },
        stGemi: {
          Ucretsizler: [],
          Ucretliler: [],
          Kategori: null,
          GenelMudur: null,
          SatisMuduru: null,
          MuhasebeMuduru: null,
          Donem1: null,
          Donem2: null,
          BarLokanta: null,
          KonferansOda: null,
          OdaKonum: [],
          MinKisi: null,
          OpSure: null,
          Bedava1: null,
          Bedava2: null,
          Cocuk1: null,
          Cocuk2: null,
          OtelTip: null,
          AutoCreate: null,
        },
        stDiger: {
          Donem1: null,
          Donem2: null,
          Aktivite: [],
        },
        stTurOperatoru: {
          FatPara: null,
          Donem1: null,
          Donem2: null,
        },
        stKonsolosluk: {
          Saat1: null,
          Saat2: null,
          Gerekliler: null,
          VizeTip: 0,
        },
        stSigorta: null,
        stFeribot: {
          TurOperatoru: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
        },
        stGolf: {
          OtelKod: {
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
        },
      },
      saticiTipi: [
        {
          text: "Yurtiçi",
          value: 0,
        },
        {
          text: "Yurtdışı",
          value: 1,
        },
      ],

      snackbar: false,
      mesaj: null,
      valid: true,
    };
  },

  mounted() {},
  methods: {
    Kaydet() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      if (this.$refs.formsatici.validate()) {
        this.Satici.SaticiTipi = this.saticiKod;
        var prm = this.Satici;
        tool.http_post(this, "SaticiKayit", prm).then(
          (response) => {
            if (response.body.Status == true) {
              var r = {
                id: response.body.Satici.Ref,
                isim: response.body.Satici.Isim,
                kod: response.body.Satici.Kod,
                isimAra: null,
                YurtIci_YurtDisi: response.body.Satici.Ic_Dis,
              };

              this.val = r;
              this.Satici.Isim = null;
              this.Satici.Kod = null;
              this.mesaj = "Kayıt edildi";
              this.snackbar = true;
              this.dialogShow = false;
            } else {
              this.val = false;
              this.mesaj = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },
          (response) => {
            this.val = false;
            this.mesaj = "Service Unavailable";
            this.snackbar = true;
          }
        );
      } else {
        this.active = 0;
      }
    },
    miniSaticiEkle() {
      this.dialogShow = true;
    },
  },
};

function menuClick(v) {}
</script>